import { Box, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import AddButton from 'modules/shift_management/components/ShiftManagement/AddButton'

interface Props {
  onClick: () => void
}

const AddUnassignedShiftButton = ({ onClick }: Props) => {
  const [isHovering, toggleHovering] = useToggle(false)

  return (
    <>
      <Box
        height="s40"
        width="full"
        paddingTop="s8"
        background="grey100"
        borderRadius={{ all: 'abs008' }}
        justifyContent="center"
        alignItems="center"
        onMouseEnter={toggleHovering(true)}
        onMouseLeave={toggleHovering(false)}
      >
        <AddButton onClick={onClick} isVisible={isHovering} />
      </Box>
    </>
  )
}

export default observer(AddUnassignedShiftButton)
